import { MinimalLayout } from '@/components/layouts/MinimalLayout'
import { Navbar } from '@/components/nav/Navbar'

import { ProjectsTable } from '@/pages/ProjectsPage/components/ProjectsTable'
import { ProjectsFilters } from './components/ProjectsFilters'
import { CreateNewDocumentButton } from './components/CreateNewDocumentButton'
import { useIsReadOnly } from '../CADPage/hooks/useIsReadOnly'

export const ProjectsPage = () => {
  const { data } = useIsReadOnly()
  return (
    <MinimalLayout>
      <Navbar>
        <div className="flex items-center space-x-4 h-10 py-8 w-full"></div>
        {!data?.isUserReadOnly && <CreateNewDocumentButton />}
      </Navbar>
      <div className="relative mt-4 py-4 px-2 w-full rounded-xl bg-white">
        <div className="flex items-center justify-between">
          <h1 className="text-normal font-semibold tracking-[-0.015em] text-zinc-950 mx-10">
            Projects
          </h1>
          <ProjectsFilters />
        </div>
        <ProjectsTable />
      </div>
    </MinimalLayout>
  )
}
